import React from 'react';
import { ArrowDownIcon, BookOpenIcon, PrinterIcon, ScissorsIcon } from 'lucide-react';
import { BowMark } from './BowMark';
import { CollectionMockup } from './CollectionMockup';
import { BRAND, OFFER_ANCHOR } from '../data/collection';
import { primaryButtonClass } from '../utils/buttonStyles';
import { scrollToAnchor } from '../utils/scrollToAnchor';
const HIGHLIGHTS = [{
  icon: PrinterIcon,
  label: 'Moldes A4 para imprimir en casa'
}, {
  icon: ScissorsIcon,
  label: 'Margen de costura incluido'
}, {
  icon: BookOpenIcon,
  label: 'Manual paso a paso'
}];

/**
 * Mobile order: label, title, subtitle, image, three highlights, button, payment note.
 * Desktop: copy + highlights + button on the left, image on the right.
 */
export function Hero() {
  return <section id="inicio" aria-labelledby="hero-title" className="w-full bg-ivory" data-id="element-70" data-mp="nekmesudpgrw">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 px-5 pb-10 pt-6 text-center sm:px-8 sm:pt-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:grid-rows-[auto_auto] lg:gap-x-12 lg:gap-y-8 lg:pb-24 lg:pt-14 lg:text-left" data-id="element-71" data-mp="3d2tln1u126au">
        <div className="animate-hero-copy min-w-0 lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-72" data-mp="3o7bzrwu0yng3">
          <p className="flex items-center justify-center gap-2 lg:justify-start" data-id="element-73" data-mp="39alawhhz8u4q">
            <BowMark className="h-6 w-9 shrink-0" data-id="element-74" data-mp="39cpawocr98zq" />
            <span className="font-serif text-[1.3rem] font-semibold italic leading-none text-coral-ink sm:text-[1.5rem]" data-id="element-75" data-mp="3e8ecsyc8z1z7">
              {BRAND.name}
            </span>
          </p>
          <p className="mt-4 inline-flex items-center rounded-full bg-sage-tint px-3.5 py-1.5 text-[0.9rem] font-bold text-sage-ink" data-id="element-76" data-mp="358zqmb345dki">
            De recién nacido a 4 años · 10 talles
          </p>

          <h1 id="hero-title" className="mt-4 font-serif text-[1.85rem] font-semibold leading-[1.1] text-graphite text-balance min-[390px]:text-[2rem] sm:text-[2.6rem] lg:mt-5 lg:text-[3.2rem] lg:leading-[1.06]" data-id="element-77" data-mp="2vi53l4i1m9y0">
            Cosé la ropa más linda para los más chiquitos, con{' '}
            <span className="text-coral-ink" data-id="element-78" data-mp="s332p6wnmcud">310 moldes listos para imprimir</span>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-[1.05rem] leading-relaxed text-graphite-soft text-pretty sm:text-[1.12rem] lg:mx-0 lg:mt-5 lg:text-[1.2rem]" data-id="element-79" data-mp="na9yql90f8jc">
            31 modelos de vestidos, ranitas, enteritos y conjuntos en 10 talles, cada uno con su manual paso a paso.
            Para coserles a tus nietos, a tus hijos o para vender.
          </p>
        </div>

        <div className="animate-hero-media min-w-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-80" data-mp="161axp9a4r42w">
          <CollectionMockup priority className="max-w-[min(270px,100%)] sm:max-w-[360px] lg:max-w-[600px]" data-id="element-81" data-mp="111yagnfcjuzs" />
        </div>

        <div className="min-w-0 lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-82" data-mp="x0cugt7in0ld">
          <ul className="mx-auto grid max-w-md grid-cols-3 gap-2 sm:gap-4 lg:mx-0" data-id="element-83" data-mp="3lt73mli5bhrm">
            {HIGHLIGHTS.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex min-w-0 flex-col items-center gap-2 text-center lg:items-start lg:text-left" data-id="element-84" data-mp="3htg864hocdgr">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-blush text-coral-ink" data-id="element-85" data-mp="21awemc9yyxi0">
                  <Icon className="h-5 w-5" aria-hidden data-id="element-86" data-mp="269hci51r153a" />
                </span>
                <span className="text-[0.85rem] font-semibold leading-snug text-graphite sm:text-[0.92rem]" data-id="element-87" data-mp="2b0pnh5iq8yik">{label}</span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-88" data-mp="2fzj436tb95my">
            <a href={OFFER_ANCHOR} onClick={event => {
            if (scrollToAnchor(OFFER_ANCHOR)) event.preventDefault();
          }} className={primaryButtonClass('hero')} data-id="element-89" data-mp="2kyn9dmd46j80">
              Quiero los 310 moldes
              <ArrowDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden data-id="element-90" data-mp="2tx7o6cfk08qy" />
            </a>
          </div>
          <p className="mt-3 text-[0.92rem] font-semibold leading-relaxed text-graphite-soft" data-id="element-91" data-mp="4b45noxezwhc">
            Pago único $19.900 · 2 cuotas sin interés · Descarga inmediata en PDF
          </p>
        </div>
      </div>
    </section>;
}